import $ = require("jquery");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Services = require("../services/ogc/wfs-readers");
import View = require("./base/geoquery-form-tool");

class Tool extends View {

    static about = `
WFS query form builder.
    `;

    createForm(args = this.args) {

        let mediator = this.mediator;
        let options = this.options;

        Utils.ifOption(options, "url", url => {
            Utils.ifOption(options, "typeName", typeName => {

                Services.WfsDescribeFeatureReader.read({
                    url: url,
                    typeName: typeName
                }).done(fields => super.createForm({
                    metadata: fields
                }));
            });

        });

    }

}

export = Tool; 